import { render, staticRenderFns } from "./newServiceCharge.vue?vue&type=template&id=33486166&scoped=true"
import script from "./newServiceCharge.vue?vue&type=script&lang=js"
export * from "./newServiceCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33486166",
  null
  
)

export default component.exports